import { api } from '../../api/client';
import type { PendingYandexRegistration, YandexOAuthFlow } from './yandex';
import type { RegistrationRole } from '../registration/model';

export function startOidc(provider: 'google' | 'apple', role: RegistrationRole, flow: YandexOAuthFlow) {
  window.location.assign(`/api/auth/${provider}/start/?${new URLSearchParams({ role, flow })}`);
}

export function loadPendingOidc(provider: 'google' | 'apple') {
  return api<PendingYandexRegistration>(`/api/auth/${provider}/pending/`);
}

export function oidcErrorMessage(provider: string, code: string | null) {
  if (!code) return '';
  const name = provider === 'apple' ? 'Apple' : 'Google';
  if (code === 'not_configured') return `${name} sign-in is not configured yet. Please use your email.`;
  if (code === 'access_denied') return `${name} sign-in was cancelled.`;
  if (code === 'email_exists') return `An account with this email already exists. Sign in with your password to link ${name}.`;
  if (code === 'role_missing') return 'Your LOVO account does not have the selected role.';
  if (code === 'account_disabled') return 'This LOVO account is disabled. Please contact support.';
  if (code === 'invalid_state') return 'Your sign-in session expired or does not match this browser. Please try again.';
  return `${name} sign-in failed. Please try again or use your email.`;
}
